import ProviderPromoCodeInfo from './components/ProviderPromoCodeInfo.js';
import connect from './connect';
import './assets/ProviderPromoCodeInfo.css';

export default connect(ProviderPromoCodeInfo);



// WEBPACK FOOTER //
// ./src/routes/ProviderPromoCodeInfo/index.js